<template>
    <div aria-live="assertive">
        <div class="col-xs-12">
            <div class="d-flex-row flex-justify-between">
                <p id="title" role="heading" aria-level="1" tabindex="0"><i class="fa fa-file-text"></i> Instruções da prova</p>
            </div>
        </div>
        <div class="col-xs-12 p-x-sm" v-if="configs !== null">
            <div v-if="result.forbidden || result.forbidden_ip">
                <h3>Você não pode acessar essa prova</h3>
            </div>
            <div v-else-if="result.release_error_message">
               <div class="flex-justify-center flex-align-center d-flex-row">
                    <div class="d-flex-column flex-align-start">
                        <h3 class="m-b-xl"> {{result.release_error_message}} </h3>
                        <h3 class="m-b-xl"> {{result.institution_channel_message}} </h3>
                        <div v-for="(description, channel) in result.institution_channel" :key="channel" class="m-b-sm">
                            <h3>{{channel}} : {{description}}</h3>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <component :is="'script'" async>
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());

                    gtag('config', 'UA-25429312-24', {
                    "user_id": "{{ this.$route.params.key }}"
                    });
                    gtag('event', 'pageview');
                </component>

                <div id="no-photo-container"
                     v-if="showNoCandidatePhotoAlert()"
                     class="col-md-12 m-t-lg">

                    <section class="card text-left p-10">
                        <header>
                            <i class="fa fa-warning m-r-sm"></i>
                            Aluno(a) sem foto
                        </header>
                        <div>
                            <p>
                                Detectamos que você não tem uma foto cadastrada no sistema.
                            </p>
                            <p>
                                Posicione-se em um ambiente com boa luminosidade sem interferência de luz direta que possa ofuscar
                                ou reduzir a eficácia da sua identificação. É proibido o uso de itens que prejudiquem a
                                identificação como boné com a aba voltada para a frente e óculos escuros.
                            </p>
                        </div>
                    </section>
                </div>

                <div id="incompatible-browser"
                     v-if="showForbiddenBrowserAlert()"
                     class="col-md-12 m-t-lg">
                    <section class="card text-left p-10">
                        <header>
                            <i class="fa fa-warning red-color m-r-6"></i>
                            Navegador não suportado
                        </header>
                        <div class="panel-body">
                            <p>
                                Detectamos que você está utilizando um navegador que não suporta o modo de tela cheia.
                                Por favor, atualize seu navegador ou baixe outro que possui suporte.
                            </p>
                            <div class="col-md-2 col-xs-6 text-center m-t-20">
                                <a target="_blank" href="https://www.google.com/chrome" class="show m-t-lg">
                                    <img alt="Logo do Google Chrome" src="data:image/png;base64,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" style="width: 15px">
                                </a>
                                <a target="_blank" href="https://www.google.com/chrome" class="show m-t-lg">
                                    Chrome
                                </a>
                            </div>
                            <div class="col-md-2 col-xs-6 text-center m-t-20">
                                <a target="_blank" href="https://www.mozilla.org" class="show m-t-lg">
                                    <img alt="Logo do mozilla" src="data:image/png;base64,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" style="width: 15px">
                                </a>
                                <a target="_blank" href="https://www.mozilla.org" class="show m-t-lg">
                                    Firefox
                                </a>
                            </div>
                        </div>
                    </section>
                </div>

                <div id="safe-browser-exam-container"
                     v-if="showSafeExamBrowserAlert()"
                     class="col-md-12 m-t-lg">

                    <div v-if="JSON.stringify(configs.variables.custom_safe_exam_browser_message) !== '{}'">
                        <section class="card p-10 text-left">
                            <header>
                                <i class="fa fa-warning yellow-color m-r-6"></i>
                                <span v-if="configs.variables.custom_safe_exam_browser_message.header">
                                    {{ configs.variables.custom_safe_exam_browser_message.header }}
                                </span>
                                <span v-else>Safe Exam Browser</span>
                            </header>
                            <div class="panel-body m-t-md">
                                <div v-if="configs.variables.custom_safe_exam_browser_message.body">
                                    <small style="white-space:pre-wrap;">{{ configs.variables.custom_safe_exam_browser_message.body }}</small>
                                </div>
                                <div v-else>
                                    <p>
                                        Esta avaliação deverá ser realizada utilizando o Safe Exam Browser.
                                    </p>
                                    <p>
                                        Caso você ainda não tenha o software instalado,
                                        <a target="blank"
                                           href="https://bitbucket.org/jpbms/safe-exam-browser-downloads/raw/45f06f3f37a621ce1c72e7e699f4a5dce7921d16/SEB_3.10.1.864_SetupBundle.exe"
                                           class="link-color">
                                            clique aqui
                                        </a>
                                        para fazer o download.
                                    </p>
                                </div>
                                <div v-if="configs.variables.custom_safe_exam_browser_message.button"
                                     class=" col-xs-12m-b-md m-t-xl">
                                    <a :href="getUrlSeb()"
                                       class="btn btn-sm btn-danger m-t-20">
                                        {{ configs.variables.custom_safe_exam_browser_message.button }}
                                    </a>
                                </div>
                                <div v-else class=" col-xs-12m-b-md m-t-xl">
                                    <a :href="getUrlSeb()"
                                       class="btn btn-sm btn-danger m-t-20">
                                        Ir para o Safe Exam Browser
                                    </a>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div v-else>
                        <section class="card p-10 text-left">
                            <header>
                                <i class="fa fa-warning m-r-6"></i>
                                Safe Exam Browser
                            </header>
                            <div class="m-t-md">
                                <p>
                                    Esta avaliação deverá ser realizada utilizando o Safe Exam Browser.
                                </p>
                                <p>
                                    Caso você ainda não tenha o software instalado,
                                    <a target="blank"
                                           href="https://bitbucket.org/jpbms/safe-exam-browser-downloads/raw/45f06f3f37a621ce1c72e7e699f4a5dce7921d16/SEB_3.10.1.864_SetupBundle.exe"
                                       class="link-color">
                                        clique aqui
                                    </a>
                                    para fazer o download.
                                </p>
                                <div class="col-xs-12 p-0 m-b-md m-t-xl">
                                    <a :href="getUrlSeb()"
                                       class="btn btn-sm btn-primary m-t-20">
                                        Ir para o Safe Exam Browser
                                    </a>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>

                <div id="incompatible-seb-browser"
                     v-if="showOutdatedSEBAlert()"
                     class="col-md-12 m-t-lg">
                    <section class="card p-10 text-left">
                        <header>
                            <i class="fa fa-warning red-color m-r-6"></i>
                            Navegador não suportado
                        </header>
                        <div>
                            <p>
                                O Safe Exam Browser está desatualizado. Retorne à tela anterior para realizar o download da versão compatível.
                            </p>
                        </div>
                    </section>
                </div>

                <div id="informations-container" class="col-md-12 m-t-lg" v-if="assessment">
                    <section class="card p-10 text-left">
                        <header>
                            <strong>Informações da prova</strong>
                        </header>
                        <div class="panel-body information-container">
                            <div class="col-xs-12">
                                <p class="color-danger" v-if="!hasTimeRemaining() && !assessment.configs.finished">
                                    <i class="fa fa-warning"></i> O tempo para fazer a prova acabou! Por favor, clique
                                    em Entregar Prova Online.
                                </p>
                                <p class="color-danger" v-if="hasTimeRemaining() && assessment.configs.started" aria-describedby="btnContinue">
                                    <i class="fa fa-warning"></i> Há uma prova em andamento, prossiga clicando em
                                    "Continuar Prova Online"!
                                </p>
                                <p class="color-danger" v-if="assessment.configs.finished">
                                    <i class="fa fa-warning"></i> Você já realizou esta prova{{ typeof(assessment.configs.finished) == "boolean" ? '' : ' em ' + formatDbDatetime(assessment.configs.finished)}}.
                                </p>
                            </div>
                            <div class="col-md-6">
                                <p>
                                    <i class="fa fa-user m-l-xs m-r-xs"></i> <span>{{ assessment.configs.exam.candidate.name }}</span>
                                </p>
                                <p>
                                    <i class="fa fa-id-card"></i> <span>{{ assessment.configs.exam.candidate.enrollment }}</span>
                                </p>
                                <p v-if="!configs.variables.hide_date_time_online_test_candidate">
                                    <i class="fa fa-calendar m-l-xs"></i> <span>{{ assessment.configs.exam.name }}</span>
                                </p>
                                <p>
                                    <b id="tempoDuracaoLabel">Tempo de duração: </b>
                                    <span aria-labelledby="tempoDuracaoLabel">
                                        {{ secondsToDate(assessment.configs.online_test_total_duration) }}
                                    </span>
                                </p>
                                <VueAnnouncer/>
                                <div v-if="assessment.configs.online_test_duration" aria-hidden="true">
                                    <b>Tempo restante: </b>
                                    <span>
                                        <span v-if="!enableCountDownTimer()">
                                            {{ secondsToDate(assessment.configs.online_test_duration) }}
                                        </span>
                                        <span v-else>
                                            {{ secondsToDate(timerCount) }}
                                        </span>
                                    </span>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <p v-for="(academic_name, academic_config) in assessment.configs.academic_tree_description" :key="academic_name">
                                    <b id="{{academic_name}}'label'">{{ academic_config }}: </b>
                                    <span aria-labelledby="{{academic_name}}'label'">
                                        {{ academic_name }}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </section>
                </div>

                <div id="instructions-container" class="col-md-12 m-t-lg" v-if="assessment && assessment.configs.exam.instructions.length > 0">
                    <section class="card p-10 text-left">
                        <header class="panel-heading">
                            Instruções
                        </header>
                        <div class="panel-body">
                            <div v-for="instruction in assessment.configs.exam.instructions" :key="instruction">
                                <div v-html="instruction"></div>
                            </div>
                        </div>
                    </section>
                </div>

                <div id="lgpd-container" class="col-md-12 m-t-lg" v-if="useFacialRecognition() && assessment">
                    <section class="card p-10 text-left">
                        <header class="m-b-lg">
                            Termo de Consentimento (LGPD)
                        </header>
                        <div class="panel-body">
                            Ao clicar em "Concordo com o termo de consentimento", você <strong>MANIFESTA seu expresso consentimento
                            à</strong> STARLINE TECNOLOGIA S/A (“STARLINE”) <strong>para captura em tempo real</strong>, por meio de
                            <strong>software de reconhecimento facial</strong>, da sua <strong>imagem e do ambiente</strong> em
                            que se encontra durante todo o período de aplicação da prova online. Você <strong>DECLARA estar ciente
                            </strong>que a sua avaliação é condicionada à habilitação da câmera web e <strong>AUTORIZA</strong> a
                            STARLINE a armazenar, tratar e utilizar o material capturado contendo sua imagem e ambiente pelo
                            período de 5 (cinco) anos, para as finalidades específicas de gerar relatórios e outros documentos
                            para <strong>controle e monitoramento das suas atividades</strong> durante a prova online; e
                            <strong>compartilhar estes materiais</strong> com a instituição de ensino responsável pelas avaliações.
                            Para mais informações, <a href="https://s3-sa-east-1.amazonaws.com/starline.cdn/termos/Starline+-+Pol%C3%ADtica+de+Privacidade+-+08-06-2021.pdf" target="_blank">
                            clique aqui</a> para acessar a Política de Privacidade da <strong>STARLINE</strong>.
                        </div>
                    </section>
                </div>

                <div id="internet-speed-warning" class="col-md-12 m-t-lg" v-if="configs.variables.native_proctoring">
                    <section class="card p-10 text-center">
                        <div class="panel-body">
                            <strong>Velocidade de conexão mínima recomendada: 20Mbps</strong>
                        </div>
                    </section>
                </div>

                <div id="start-exam-container" v-if="canTheTestBeStarted() && assessment" class="m-t-lg col-xs-12 p-0">
                    <div class="col-xs-12 text-left" v-if="assessment.configs.exam.instructions.length > 0">
                        <label class="checkbox-custom check-success m-0">
                            <input id="accept-instructions" type="checkbox" v-model="instructionAccepted">
                            <label for="accept-instructions" class="m-r-0">
                                Concordo com as Instruções
                            </label>
                        </label>
                    </div>

                    <div class="col-xs-12 text-left" v-if="useFacialRecognition()">
                        <label class="checkbox-custom check-success m-0">
                            <input id="accept-terms" type="checkbox" v-model="termsAccepted">
                            <label for="accept-terms" class="m-r-0">
                                Concordo com o Termo de Consentimento
                            </label>
                        </label>
                    </div>

                    <div class="col-xs-12 text-right m-b-xl">
                        <div>
                            <button class="btn btn-primary" id="btnContinue" v-if="hasTimeRemaining()" @click="startTestBtn()"
                               v-bind="(blockStartTest() || loadingTest) ? {'disabled': ''} : {}">
                                {{ assessment.configs.started ? "Continuar" : "Iniciar" }} prova online
                            </button>
                            <a class="btn btn-primary" @click="finishOnlineTest()"
                               v-if="!hasTimeRemaining() && !assessment.configs.finished">
                                Entregar Prova Online
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else
             class="col-xs-12 d-flex-column align-center flex-justify-center text-center h-100vh overflow-hidden">
            <i class="fa fa-5x fa-circle-o-notch fa-spin"></i>
        </div>

        <take-candidate-document-photo v-if="showModalCandidateDocument"
                                       :finishFunction="candidatePhotoCallback"
                                       :nativeProctoring="configs.variables.native_proctoring"/>
        <take-snap-shot v-if="showModalSnapShot" :goToFaceRecognition="goToFaceRecognition"
                        :nativeProctoring="configs.variables.native_proctoring"/>

        <face-recognition-modal v-if="showModalFaceRecognition"
                                :onRecognitionSuccess="startOnlineTest"
                                :isFirstRecognition="true">
        </face-recognition-modal>
        <environment-recognition-modal v-if="showModalEnvironmentRecognition"
                                :onEnvRecognitionSuccess="closeModalEnvironmentRecognition">
        </environment-recognition-modal>

        <modal-dialog v-show="showAccessErrorModal" @close="showAccessErrorModal = false">
            <h3 class="m-b-md text-left">Ocorreu um erro ao acessar a prova.</h3>
            <p>
                Não é possível prosseguir com a prova no momento,
                verifique as configurações de seu navegador e certifique-se de que
                o mesmo está com as configurações de cookies habilitadas.
            </p>
        </modal-dialog>
        <modal-dialog v-show="showSharingScreenErrorModal" @close="showSharingScreenErrorModal = false">
            <h3 class="m-b-md text-left">Ocorreu um erro ao acessar a prova.</h3>
            <p>Houve um erro no compartilhamento de tela e não é possível prosseguir para a prova no momento.
               Habilite o compartilhamento de tela cheia do monitor e tente novamente.</p>
        </modal-dialog>
        <modal-dialog v-show="showFinishedTestModal" @close="showFinishedTestModal = false" :hide-close="true">
            <div>
                <h3 class="m-b-md">Prova finalizada com sucesso</h3>
                <router-link class="btn btn-primary d-block" :to="`/`">
                    Voltar para a página inicial
                </router-link>
            </div>
        </modal-dialog>
        <modal-dialog v-show="showFinishTestErrorModal" @close="showFinishTestErrorModal = false">
            <h3 class="m-b-md text-left">Ocorreu um erro ao finalizar a prova.</h3>
            Não é possível prosseguir com o encerramento da prova no momento, tente novamente em instantes. Ou entre em contato com sua instituição.
        </modal-dialog>

        <modal-dialog v-show="showModalBlockedBrowser" :hide-close="true">
            <div>
                <h3 class="m-b-md">Atenção: Navegador Não Suportado</h3>
                <p>Parece que você está usando o navegador Firefox.
                   Lamentamos informar que, no momento, para prova com monitoramento, nosso sistema não oferece suporte completo para este navegador.
                   Para uma melhor experiência, recomendamos o uso de navegadores como Google Chrome, Safari ou Microsoft Edge.</p>
                <router-link class="btn btn-primary d-block" :to="`/`">
                    Voltar para a página inicial
                </router-link>
            </div>
        </modal-dialog>

    </div>
</template>

<script>
    import {
        getTestUrl,
        getOnlineTestConfigs,
        getOnlineTestInstructions, postTestUrl
    } from "../../../scripts/apiService/tests";
    import {formatDbDatetime, secondsToDate, setCookie} from "../../../scripts/utils";
    import ModalDialog from "../../base/Modal";
    import TakeSnapShot from "../../includes/FaceRecognition/takeSnapShot";
    import FaceRecognitionModal from "../../includes/FaceRecognition/FaceRecognitionDirectiveModal";
    import takeCandidateDocumentPhoto from "../../includes/FaceRecognition/takeCandidateDocumentPhoto";
    import EnvironmentRecognitionModal from "../../includes/EnvironmentRecognition/EnvironmentRecognitionModal";
    import { initScreenStream } from "../../../scripts/screenSharingStream";
    import { screenSharingStatus$ } from "../../../scripts/observableStates";

    export default {
        name: 'OnlineTestInstructions',
        components: {FaceRecognitionModal, TakeSnapShot, takeCandidateDocumentPhoto, EnvironmentRecognitionModal, ModalDialog},
        data: () => {
            return {
                result: null,
                configs: null,
                assessment: null,
                timerCount: 0,
                instructionAccepted: false,
                termsAccepted: false,
                loadingTest: false,
                showModalSnapShot: false,
                showModalCandidateDocument: false,
                showModalFaceRecognition: false,
                showModalEnvironmentRecognition: false,
                showAccessErrorModal: false,
                showFinishedTestModal: false,
                showFinishTestErrorModal: false,
                screenSharingStatusSubscription: null,
                showSharingScreenErrorModal: false,
                showModalBlockedBrowser: false,
                timerInterval: null
            }
        },
        methods: {
            formatDbDatetime: formatDbDatetime,
            secondsToDate: secondsToDate,
            blockStartTest() {
                let variables = this.configs.variables;
                if (!this.termsAccepted && this.useFacialRecognition())
                    return true;

                if (this.result.forbidden_browser ||
                    (variables.use_safe_exam_browser && !variables.is_safe_exam_browser_started) ||
                    this.showOutdatedSEBAlert())
                    return true;

                if (this.assessment.configs.exam.instructions.length > 0 && !this.instructionAccepted){
                    return true;
                }

                return false;
            },
            showNoCandidatePhotoAlert() {
                let configs = this.configs;
                return this.useFacialRecognition() && configs.variables.candidate_has_no_photo;
            },
            showForbiddenBrowserAlert() {
                return this.result.forbidden_browser && !this.configs.variables.is_safe_exam_browser_started;
            },
            showSafeExamBrowserAlert() {
                let configs = this.configs;
                return configs.variables.use_safe_exam_browser && !configs.variables.is_safe_exam_browser_started
                    && !this.result.forbidden_browser;
            },
            showOutdatedSEBAlert() {
                let configs = this.configs;
                return configs.variables.use_safe_exam_browser && configs.variables.is_safe_exam_browser_started
                    && this.result.forbidden_browser;
            },
            getUrlSeb() {
                return this.configs.urls.safe_exam_browser_new
            },
            enableCountDownTimer() {
                return this.assessment.configs.started
                    || this.assessment.configs.online_test_duration < this.assessment.configs.online_test_total_duration;
            },
            hasTimeRemaining() {
                return this.assessment.configs.online_test_duration !== 0
            },
            useFacialRecognition() {
                return this.configs.variables.enable_facial_recognition || this.configs.variables.enable_take_photo;
            },
            canTheTestBeStarted() {
                if (this.result.forbidden_browser && !this.configs.variables.is_safe_exam_browser_started) {return false;}
                if (this.configs.variables.use_safe_exam_browser) {
                    return !!this.configs.variables.is_safe_exam_browser_started;
                }
                return true;
            },
            startTestBtn(){

                if(this.configs.variables.native_proctoring){

                    if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1){
                        this.showModalBlockedBrowser = true;
                        return;
                    }

                    this.loadingTest = true;
                    initScreenStream();
                    if(!this.screenSharingStatusSubscription)
                        this.screenSharingStatusSubscription = screenSharingStatus$.get().subscribe( obj => {
                                if(obj){
                                    if(obj.state === "streaming"){
                                        this.stepsBeforeStart();
                                        if(this.screenSharingStatusSubscription) this.screenSharingStatusSubscription.unsubscribe();
                                    }
                                    else this.showSharingScreenErrorModal = true;
                                    this.loadingTest = false;
                                }
                            }
                        );
                }
                else this.stepsBeforeStart();
            },
            stepsBeforeStart() {
                if(!this.assessment.configs.started && this.configs.variables.enable_environment_recognition){
                    this.showModalEnvironmentRecognition = true;
                }
                else this.recognitionSteps();
            },
            recognitionSteps(){
                if (this.useFacialRecognition()) {
                    if (this.checkRequireDocument()){
                        this.showModalCandidateDocument = true;
                    } else if (this.configs.variables.candidate_has_no_photo) {
                        this.showModalSnapShot = true;
                    } else {
                        this.goToFaceRecognition()
                    }
                } else {
                    this.startOnlineTest();
                }
            },
            closeModalEnvironmentRecognition(){
                this.showModalEnvironmentRecognition = false;
                this.recognitionSteps();
            },
            checkRequireDocument(){
                return this.configs.variables.require_candidate_document && !this.assessment.configs.started;
            },
            candidatePhotoCallback(){
                if (this.configs.variables.candidate_has_no_photo) {
                    this.showModalSnapShot = true;
                } else {
                    this.goToFaceRecognition()
                }
            },
            goToFaceRecognition(candidatePhoto){
                this.configs.variables.candidate_photo = this.configs.variables.candidate_photo ?? candidatePhoto;
                this.showModalSnapShot = false;
                this.showModalFaceRecognition = true;
            },
            startOnlineTest() {
                if (this.assessment.configs.finished) {
                    return;
                }

                this.loadingTest = true;

                let startPromise = async () => {
                    if (this.enableCountDownTimer()) {
                        this.assessment.configs.online_test_duration = this.timerCount;
                    }
                    this.$router.push(`/online-tests/${this.$route.params.key}/loading`);
                };
                startPromise().catch((error) => {
                    this.showAccessErrorModal = true;
                    console.log(error);
                })
                .finally(() => {
                    this.loadingTest = false;
                });
            },
            finishOnlineTest() {
                window.dataLayer = window.dataLayer || [];
                function gtag(){window.dataLayer.push(arguments);}
                gtag('event', 'finishExam', {
                    "event_category": "buttonAction",
                    "event_label": "Finish Online Exam"
                });

                let action = this.configs.variables.exam_finished_by_candidate_complete;
                // TODO: Verificar se a action é essa mesma sempre

                let url = this.configs.urls.exam_save;
                url = url.replace("/" + this.configs.variables.client_slug + "/", "");

                postTestUrl(this.$route.params.key, url, {action: action})
                    .then(() => {
                        this.showFinishedTestModal = true;
                    }).catch(() => {
                        this.showFinishTestErrorModal = true;
                    });
            }
        },
        mounted() {
            getOnlineTestInstructions(this.$route.params.key).then((response) => {
                setCookie("firestore_token", response.data["firestore_token"]);
                getOnlineTestConfigs(this.$route.params.key).then((configResponse) => {
                    this.result = response.data;
                    this.configs = configResponse.data;
                    let exam_configs_url = this.configs.urls.exam_configs;
                    exam_configs_url = exam_configs_url.replace("/" + this.configs.variables.client_slug + "/", "");
                    this.$store.commit("onlineTest/setConfigs", this.configs);
                    getTestUrl(this.$route.params.key, exam_configs_url).then((assessmentResponse) => {
                        this.assessment = assessmentResponse.data;
                        this.timerCount = assessmentResponse.data.configs.online_test_duration;
                        this.$store.commit("onlineTest/setAssessment", this.assessment);
                        let timerLabel = secondsToDate(this.assessment.configs.online_test_duration);
                        if(this.enableCountDownTimer()) timerLabel = secondsToDate(this.timerCount);
                        this.$announcer.set('Tempo restante de prova' + timerLabel, 'polite');
                        this.timerInterval = setInterval(() => {this.timerCount ? this.timerCount -- : this.timerCount;}, 1000);
                    });
                });
            });
            document.getElementById('title').focus();
        },
          beforeUnmount() {
            if(this.screenSharingStatusSubscription) this.screenSharingStatusSubscription.unsubscribe();
            if(this.timerInterval) clearInterval(this.timerInterval);
          }
    }
</script>
